// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2F1Qm","disabled":"FileBtn_disabled__CVd1Z","warn":"FileBtn_warn__3pTz8","fade":"FileBtn_fade__1AzE6"};